import IshEssenceSpinWheel from "./IshEssenceSpinWheel";

function App() {
  return <IshEssenceSpinWheel />;
}

export default App;